import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import {KMenuDropDown, KIcon, KTable, KDialog, KButton, useSetState} from "@kyburz/kdesign-system";


import {useDeleteMapping, useGetMappings} from "../requests/valueMappings";
import {setAlert} from "../../../redux/actions/actions";

const useStyles = makeStyles(() => ({
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  addingButton: {
    marginRight: 15,
  },
  tableContainer: {
    height: "calc(100% - 100px)",
  },
  scrollableCell: {
    overflowX: "auto",
    overflowY: "hidden",
    scrollbarWidth: "none",
    height: 20,
    "&::-webkit-scrollbar": {
      width: 0,
      height: 0,
    },
    "& > div": {
      width: "max-content",
    },
  },
}));

const TemplateValueMappers: React.FC = () => {
  const classes = useStyles();

  const history = useHistory();
  const dispatch = useDispatch();

  const [state, setState] = useSetState({
    selected: {} as Record<string, boolean>,
    someSelected: false,
    showDeleteDialog: false,
    deletedMapping: null as any,
    loadingUpdating: false,
  });

  const { data: mappings = [], request: getMappings } =
    useGetMappings();

  const { request: deleteMapping } = useDeleteMapping();


  const columns = useMemo(
    () => [
      {
        Header: "Name",
        id: "name",
        accessor: "name"
      },
      {
        accessor: "actions",
        defaultCanFilter: false,
        sticky: "right",
        Cell: (row) => (
          <KMenuDropDown
            menuItems={[
              {
                icon: "edit",
                title: "Edit",
                action: () => {
                  history.push(
                    `/config/vehicle/templates/value_mappings/${row?.row?.original?.name}`,
                  );
                }
              },
              {
                icon: "trash-2",
                title: "Delete",
                action: () =>
                  setState({
                    showDeleteDialog: true,
                    deletedMapping: row?.row?.original || null,
                  }),
              },
            ]}
          />
        ),
        width: 50,
      },
    ],
    [history, setState],
  );

  const deleteDialog = (
    <KDialog
      size="xs"
      title="Delete Mapping"
      open={state.showDeleteDialog}
      primaryCTAonClick={() => {
        deleteMapping({ name: state.deletedMapping?.name })
          .then(() =>
            setAlert(
              `Mapping ${state.deletedTemplate?.name} has been deleted`,
              "success",
            ),
          )
          .catch((response) =>
            dispatch(
              setAlert(`Delete failed! ${response?.details}`, "error"),
            ),
          )
          .then(() => setState({ showDeleteDialog: false }))
          .then(() => getMappings());
      }}
      primaryCTAColor="danger"
      primaryCTAText="Delete"
      secondaryCTAonClick={() => setState({ showDeleteDialog: false })}
      secondaryCTAText="Cancel"
    >
      <p>Are you sure you want to delete {state.deletedMapping?.name}?</p>
    </KDialog>
  );

  return (
    <>
      <div className={classes.buttons}>
        <KButton
          icon={<KIcon icon="plus" />}
          onClick={() => history.push("/config/vehicle/templates/value_mappings/create/editor")}
          className={classes.addingButton}
        >
          New
        </KButton>
      </div>
      <div className={classes.tableContainer}>
        <KTable
          data={mappings}
          columns={columns}
        />
      </div>
      {deleteDialog}
    </>
  );
};

export default TemplateValueMappers;
